import App from '../App.vue'

export default  {
    path: '/committee',
    meta: { title: '专委会' },
    component: App,
    children:[
        {
            path: 'list',
            component: () => import('../views/Committee/List.vue'),
            meta: {
                title: '专委会列表',
            }
        },
        {
            path: 'detail/:committee_id',
            component: () => import('../views/Committee/Detail.vue'),
            meta: {
                title: '专委会列表',
            }
        },
        {
            path: 'member-user/list',
            component: () => import('../views/Committee/MemberUserList.vue'),
            meta: {
                title: '专委会会员列表',
            }
        },
        {
            path: 'member-user/detail/:member_user_id',
            component: () => import('../views/Committee/MemberUserDetail.vue'),
            meta: {
                title: '专委会会员详情',
            }
        },
        {
            path: 'member-user-order/list',
            component: () => import('../views/Committee/MemberUserOrderList.vue'),
            meta: {
                title: '会员订单列表',
            }
        },
        // {
        //     path: 'member-user-order/new/:committee_id',
        //     component: () => import('../views/Committee/MemberUserOrderNew.vue'),
        //     meta: {
        //         title: '新建会员订单',
        //     }
        // },
        {
            path: 'member-user-order/detail/:member_user_order_id',
            component: () => import('../views/Committee/MemberUserOrderDetail.vue'),
            meta: {
                title: '会员订单详情',
            }
        }
    ]
}